import React from 'react';
import { Search } from 'lucide-react';

// Renders one persisted ChatMessage (chat_bot.md §3.3). An assistant turn
// with `toolCalls` is an intermediate "looked something up" round persisted
// by the server (chatbotFunctions.persistReply) — shown as a small tag
// rather than a full bubble, distinct from the final plain-text reply.
export default function ChatMessageBubble({ message }) {
  const isUser = message.role === 'user';
  const hasToolCalls = message.role === 'assistant' && message.toolCalls?.length > 0;
  const time = message.createdAt ? new Date(message.createdAt).toLocaleString() : null;

  if (hasToolCalls) {
    return (
      <div className="ss-chat-bubble-row ss-chat-bubble-row--assistant">
        <div className="ss-chat-tool-tag">
          <Search size={14} aria-hidden="true" />
          <span>Looking that up…</span>
        </div>
        {message.content && (
          <div className={`ss-chat-bubble ss-chat-bubble--assistant ${message.pending ? 'ss-chat-bubble--pending' : ''}`.trim()}>
            {message.content}
          </div>
        )}
        {time && <span className="ss-chat-bubble-time">{time}</span>}
      </div>
    );
  }

  return (
    <div className={`ss-chat-bubble-row ${isUser ? 'ss-chat-bubble-row--user' : 'ss-chat-bubble-row--assistant'}`}>
      <div
        className={`ss-chat-bubble ${isUser ? 'ss-chat-bubble--user' : 'ss-chat-bubble--assistant'} ${
          message.pending ? 'ss-chat-bubble--pending' : ''
        }`.trim()}
      >
        {message.content}
      </div>
      {time && <span className="ss-chat-bubble-time">{time}</span>}
    </div>
  );
}
